import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import AlertService from "@/core/services/alert.service";
import router from '@/router'

// action types

export const PAGINATE_ALL_POPUPS = "getPaginatedPopups";
export const ALL_POPUPS = "getAllPopups";
export const GET_ALL_POPUPS = "getAllPopupsWithoutAuth";
export const CREATE_POPUP_FORM = "createPopupForm";
export const DELETE_POPUP = "deletePopup";
export const GET_POPUP_DATA = "getPopupData";
export const CREATE_POPUP = "createPopup";
export const UPDATE_POPUP = "updatePopup";


// mutation types

export const SET_PAGINATED_POPUPS = "setPaginatedPopups";
export const SET_ALL_POPUPS = "setAllPopups";
export const SET_POPUP_DATA = "setPopupData";
export const SET_POPUP_META = "setPopupMeta";
export const SET_POPUP_ERROR = "setPopupError";
export const SET_POPUP_LOADING = "setPopupLoading";
export const CLEAR_POPUP_ERROR = "clearPopupError";
export const SET_IS_DISABLED_POPUP = "setIsDisabledPopup";


const state = {
    popups: [],
    paginatedPopups: [],
    popup_data: {},
    meta_popup : {
        totalPages: 0,
        total: 0,
        from: 0,
        to: 0,
    },
    errors: [],
    loading: false,
    isDisabled: false
    };

const getters = {
   
    paginateAllPopups(state) {
        return state.paginatedPopups;
    },

    allPopups(state) {
        return state.popups;
    },

    getPopupData(state) {
        return state.popup_data;
    },

    meta_popup(state) {
        return state.meta_popup;
    },
    
};

const actions = {
 
    [PAGINATE_ALL_POPUPS](context, payload) {
        context.commit(SET_IS_DISABLED_POPUP, false);
        context.commit(SET_POPUP_LOADING, true);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.get(`/popups?size=${payload.itemsPerPage}&page=${payload.pageNumber}&sortBy=${payload.sortBy}&sortDesc=${payload.sortDesc}&searchText=${payload.search}&check=${payload.x}`)
        .then(({ data }) => {
            
            if(data == 403) {
                context.commit(SET_POPUP_LOADING, false);
                router.push('nopermission');
            }
            else {
                context.commit(SET_PAGINATED_POPUPS, data);
                context.commit(SET_POPUP_META, data);
                context.commit(SET_POPUP_LOADING, false);
            }
            
        })
        .catch(( response ) => {
            context.commit(SET_POPUP_LOADING, false);
            context.commit(SET_POPUP_ERROR, response.errors);
        });
        ;
        
    },

    [ALL_POPUPS]() {
        return new Promise(resolve => {
            ApiService.get('/popupsAll')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [GET_ALL_POPUPS]() {
        return new Promise(resolve => {
            ApiService.get('/get_active_popups')
            .then((response) => {
                resolve(response);
            })
        });
    },

    [CREATE_POPUP_FORM](context) {
        context.commit(SET_POPUP_LOADING, false);
        context.commit(SET_POPUP_ERROR, false);
        context.commit(SET_IS_DISABLED_POPUP, false);
    },

    [GET_POPUP_DATA](context, payload) {
        context.commit(SET_IS_DISABLED_POPUP, true);
        context.commit(SET_POPUP_LOADING, true);
        context.commit(CLEAR_POPUP_ERROR);
        return new Promise(resolve => {
            ApiService.get(`/popup/${payload.id}`)
            .then(( response ) => {
                if(response.data == 403) {
                    context.commit(SET_POPUP_LOADING, false);
                    router.push('/nopermission');
                }
                else {
                    context.commit(SET_POPUP_DATA, response.data);
                    context.commit(SET_POPUP_LOADING, false);
                    context.commit(SET_IS_DISABLED_POPUP, false);
                    resolve(response);
                }
            })
            .catch(({ response }) => {
                context.commit(SET_POPUP_LOADING, false);
                context.commit(SET_POPUP_ERROR, response.data.errors);
                context.commit(SET_IS_DISABLED_POPUP, true);
            });
        });
    },

    [CREATE_POPUP](context, payload) {
        context.commit(SET_POPUP_LOADING, false);
        context.commit(SET_IS_DISABLED_POPUP, true);
        context.commit(CLEAR_POPUP_ERROR);
        return ApiService.post("/popup/store", payload.data)
        .then(( response ) => {
            if(response.data == 403) {
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde ekleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                context.commit(CLEAR_POPUP_ERROR);
            }
            else{
                context.commit(SET_POPUP_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Kayıt Başarılı",
                    "Popup başarıyla kaydedilmiştir. ID numarası: " + response.data.id
                );
                context.commit(CLEAR_POPUP_ERROR);
                context.commit(SET_IS_DISABLED_POPUP, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                return response;
            }
        })
        .catch(({ response }) => {
            context.commit(SET_POPUP_LOADING, false);
            context.commit(SET_POPUP_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_POPUP, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
        });
    },

    [UPDATE_POPUP](context, payload) {
        context.commit(SET_POPUP_LOADING, true);
        context.commit(SET_IS_DISABLED_POPUP, true);
        context.commit(CLEAR_POPUP_ERROR);
        
        return ApiService.put(`/popup/${payload.data.id}`, payload.data)
        .then((response) => {
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde güncelleme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else{
                context.commit(SET_POPUP_LOADING, false);
                AlertService.makeToast(
                    "success",
                    "Güncelleme Başarılı",
                    payload.data.id + " ID numaralı popup başarıyla güncellenmiştir."
                );
            
                context.commit(SET_IS_DISABLED_POPUP, false);
                if(payload.goBack){
                    router.go(-1);    
                }
                
            return response;   
            }
                
        })
        .catch(({ response }) => {
            context.commit(SET_POPUP_LOADING, false);
            context.commit(SET_POPUP_ERROR, response.data.errors);
            context.commit(SET_IS_DISABLED_POPUP, false);
            AlertService.makeToast(
                "danger",
                "Hata!",
                "Lütfen aşağıdaki hataları düzeltiniz veya eksiklikleri gideriniz."
            );
            
        });
        
    },

    [DELETE_POPUP](context, payload) {
        context.commit(SET_POPUP_LOADING, true);
        context.commit(CLEAR_POPUP_ERROR);
        JwtService.getToken();
        ApiService.setHeader();
        ApiService.delete(`/popup/${payload.itemToDelete}`)
        .then(( response ) => {
            context.commit(SET_POPUP_LOADING, false);
            
            if(response.data == 403){
                AlertService.makeToast(
                    "warning",
                    "Yetkisiz!",
                    "Bu modül üzerinde silme yetkiniz yoktur. Lütfen sistem yöneticisi ile görüşünüz."
                );
                
            }
            else {
                
                AlertService.makeToast(
                    "success",
                    "Silme Başarılı",
                    payload.itemToDelete + " ID numaralı popup başarıyla silinmiştir."
                );
                
                
            }
        })
        .catch(( error ) => {
            context.commit(SET_POPUP_ERROR, error);
            AlertService.makeToast(
                "warning",
                "Hata!",
                error
            );
        });
        
    },

    
    
};

const mutations = {

    [SET_PAGINATED_POPUPS](state, paginatedPopups) {
        state.paginatedPopups = paginatedPopups.data;
    },

    [SET_ALL_POPUPS](state, popups) {
        state.popups = popups;
    },

    [SET_POPUP_DATA](state, popups_data) {
        state.popups_data = popups_data;
        state.errors = [];
    },

    [SET_POPUP_META](state, meta_popup) {
        state.meta_popup = meta_popup;
    },

    [SET_POPUP_ERROR](state, error) {
        state.errors = error;
    },

    [CLEAR_POPUP_ERROR](state) {
        state.errors = [];
    },
    
    [SET_POPUP_LOADING](state, loading) {
        state.loading = loading;
    },

    [SET_IS_DISABLED_POPUP](state, isDisabled) {
        state.isDisabled = isDisabled;
    },

};

export default {
    state,
    actions,
    mutations,
    getters
};
